/*
 * @Date: 2025-01-03 15:24:38
 * @LastEditors: Mipawn dongzhan@mipawn.com
 * @LastEditTime: 2025-01-04 15:47:02
 * @Author: Mipawn
 * @Description: 弹窗提示
 */

import Button from '@/components/button';

import styles from './index.module.less';

export const HintListModal = (_, onClose, innerProps) => {
  const { contents = [], cb } = innerProps;
  return (
    <div className={styles.container}>
      <ul className={styles.list}>
        {contents.map((content, index) => (
          <li key={index} className={styles.item}>
            <span>{content}</span>
          </li>
        ))}
      </ul>

      <div className={styles.btn}>
        <Button
          type="success"
          onClick={() => {
            onClose();
            if (cb) {
              cb();
            }
          }}
        >
          OK
        </Button>
      </div>
    </div>
  );
};

export default HintListModal;
